<template>
    <div>
        <div id="inventoryGraph">
    <v-card flat style="min-height:20vh;overflow-x:scroll;box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.04);border-radius: 10px;">
        <v-card-title class="subheading"><strong>Inventory by Product Line</strong>
            <v-spacer/> 
            <v-btn-toggle  v-model="inventory_type">
              <v-btn :class="inventory_type=='ats' ? 'indigo white--text' : '' " small flat value="ats">
                ATS
              </v-btn>
              <v-btn small flat value="stock" :class="inventory_type=='stock' ? 'indigo white--text' : '' ">
                Stock
              </v-btn>
            </v-btn-toggle>
            &nbsp;
            &nbsp;
            
            <v-btn-toggle v-model="display_dollar">
              <v-btn :class="display_dollar=='qty' ? 'indigo white--text' : ''" small flat value="qty">
                Qty
              </v-btn>
             
              <v-btn :class="display_dollar=='cost' ? 'indigo white--text' : ''"  v-if="user_type!='S'" small flat value="cost">
                Cost
              </v-btn>
            </v-btn-toggle>
            <v-spacer/> 
            <v-icon @click="refreshData" small class="black--text">fas fa-sync</v-icon> &nbsp; 
        </v-card-title>
        <hr>
        <v-card-text   style="min-height:300px">
            <v-container v-if="loading" class="text-xs-center" justify-center >
                 <v-progress-circular
                     class="text-xs-center"
                    v-if="loading"
                    :size="100"
                    :width="5"
                    color="green dark"
                    valvue="Loading"
                    indeterminate
                    ></v-progress-circular>
            </v-container>
        
             <div id="atsInventory"></div>
        </v-card-text>
        <v-dialog v-model="showDialog" fullscreen>
            <div id="cloneGraph">
            </div>
        </v-dialog>
    </v-card>
    </div>
    </div>
</template> 
<script>
//import SalesAnalysisModel from '../../api/service/SalesAnalysisService.js'
import ApexCharts from 'apexcharts'
import lodash from 'lodash'
import DashboardService from '@/api/service/DashboardService.js'
export default {
      components: {
           ApexCharts
      },
      data () {
          return {
              loading:false,
              user_type:"S",
              showDialog:false,
              options:{},
              dataset: [],
              legends:[],
              series:[],
              loading:false,
              display_dollar:"qty",
              inventory_type:"ats"
          }
      },
      created()  {
      },
      watch: {
          display_dollar() {
            this.refreshData()
          },
          inventory_type() {
            this.refreshData()
          }
      },
      mounted() {
         var $localStorage =JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
         this.user_type = $localStorage.data.User.user_type
         this.refreshData() 
        },
        //this.setChart()

      methods: {
          refreshData() {
              
              this.loading=true
              this.legends=[]
              this.series=[]
              //document.getElementById("#atsInventory").innerHTML = "";
            DashboardService.getInventory()
                .then($styles => {
                    if($styles.data.length<=20) {
                        var $count = $styles.data.length
                    } else {
                        var $count=$styles.data.length
                    }
                     if(this.display_dollar=='cost') {
                        if(this.inventory_type=='stock') {
                          $styles.data =lodash.orderBy($styles.data, ['qty_on_hand_cost'], ['desc']);
                        } else {
                          $styles.data =lodash.orderBy($styles.data, ['ats_cost'], ['desc']);
                        }
                     } else {
                        if(this.inventory_type=='stock') {
                          $styles.data =lodash.orderBy($styles.data, ['qty_on_hand'], ['desc']);
                        } else {
                          $styles.data =lodash.orderBy($styles.data, ['ats'], ['desc']);
                        }
                     }
                    for(var $i=0;$i<$count;$i++) {
                        //this.dataset.push({value:$styles.data[0].data.rows[$i].QTY_ON_HAND,
                        //name:$styles.data[0].data.rows[$i].NAME})
                        this.legends.push($styles.data[$i].name)
                        //+'&nbsp;&nbsp;'+$styles.data[0].data.rows[$i].QTY_ON_HAND)
                        if(this.display_dollar=='cost') {
                            this.series.push(
                                this.inventory_type=='stock' ? $styles.data[$i].qty_on_hand_cost : $styles.data[$i].ats_cost
                                )
                        } else if(this.display_dollar=='qty') {
                            this.series.push(
                                this.inventory_type=='stock' ? $styles.data[$i].qty_on_hand : $styles.data[$i].ats
                            )
                        } 
                    }
                    this.setInventory()
            })
          
          },
          setInventory($inventory) {
             this.setChart()  
            this.loading=false
          },
          showGraphMaximized() {
            var div = document.getElementById('inventoryGraph'),
            clone = div.cloneNode(true); // true means clone all childNodes and all event handlers
            clone.id = "cloneGraph1";
            this.showDialog=true
            var div2 = document.getElementById('cloneGraph')
            //document.body.appendChild(clone);
            div2.innerHtml=clone
            
          },
            formatNumber(num) {
                return this.display_dollar=='cost' ? '$' : ''+ num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
          setChart() {
            var $dollar = this.display_dollar=='cost' ? '$' : ''
            this.options =  {
                chart: {
                    width: 750,
                    type: 'donut'
                },
                series: this.series,
                labels: this.legends,
                legend: {
                    width:400,
                    fontSize:"12px",
                    formatter: function(seriesName, opts) {
                        return ['<span style="float:left;width:60%">'+seriesName+'</span>', 
                        '<span style="  width:20%;text-align:right;float:right"><strong>'+
                            $dollar+opts.w.globals.series[opts.seriesIndex].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+'</strong></span>']
                    }
                }
            }
            this.loading=true
            var chart = new ApexCharts(document.querySelector("#atsInventory"), this.options);
            chart.render();
            this.$forceUpdate()
            //alert('chart rendered')
      }
    }
}
</script>
<style scoped>
.echarts {
  width: 60%;
  height: 60%;
}
</style>